module.exports = __webpack_public_path__ + "img/19922560000121.bada9be2.png";